import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ParameterChildAttributes } from './ParameterChildAttributes';
import { ParameterDescription } from './ParameterDescription';
import { ParameterEnumValues } from './ParameterEnumValues';
import { ParameterHeading } from './ParameterHeading';
export function ParameterListItem({ parameter }) {
    return (_jsxs("div", { className: "space-y-3", children: [_jsx(ParameterHeading, { parameter: parameter }), _jsx(ParameterDescription, { parameter: parameter }), _jsx(ParameterEnumValues, { parameter: parameter }), _jsx(ParameterChildAttributes, { parameter: parameter })] }));
}
